import React, {useState, useEffect} from "react";
import { Modal } from 'react-bootstrap'

import './confirmationModalComp.css';

const ConfirmationModalComp = (props) => {

    const {
        isOpen,
        handleCloseModal,
        handleSubmit,
        title,
        message,
        extendedMessage,
        submitButtonLabel,
        cancelButtonLabel,
        optionalThirdButtonLabel,
        optionalThirdOption,
        setOptionalThirdButtonLabel
    } = props;

    const [emExpanded, setEMExpanded] = useState(false)

    const handleOnHide = () => {
        handleCloseModal()
        if (optionalThirdButtonLabel && optionalThirdButtonLabel !== "") {
            setOptionalThirdButtonLabel("")
        }
    }

    // const toggleEMExpanded = () => {
    //     setShowLineItemForm(prevState => (!prevState))
    // }

    useEffect(() => {
        if (extendedMessage) {
            setEMExpanded(true)
        }
    }, [])

    return (
        <>
            <Modal
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={isOpen}
                onHide={handleOnHide}
            >
                <Modal.Header>
                    <Modal.Title>
                        <p className="page-heading">{title}</p>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className='modal-body-text' >
                    {message.map((x, i) => (
                        <p style={{ textAlign: "center" }} key={i}>
                            {x}
                        </p>
                    ))}
                    {extendedMessage && <div>{extendedMessage}</div>}
                </Modal.Body>
                <Modal.Footer className='modal-buttons'>
                    <button style={{ backgroundColor: "red", color: "white" }} onClick={(e) => { handleSubmit(e) }}>{submitButtonLabel}</button>

                    {optionalThirdButtonLabel && optionalThirdButtonLabel !== "" &&
                        <button style={{ backgroundColor: "rgb(0, 122, 255)", color: "white" }} onClick={(e) => { optionalThirdOption(e) }}>{optionalThirdButtonLabel}</button>
                    }

                    <button style={{ backgroundColor: "lightGray" }} onClick={() => handleCloseModal()}>{cancelButtonLabel || "Cancel"}</button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
export default ConfirmationModalComp;